/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, MouseEvent, useEffect, useState} from 'react'
import {PageTitle} from '../../../../../_metronic/layout/core'
import {Datatable} from '../../../../components/Datatable/Datatable'
import {Button} from '../../../../components/Button/Button'
import {Input} from '../../../../components/Input/Input'
import {Loading} from '../../../../components/Loading/Loading'
import {POST, PUT, GET} from '../../../../services/api'
import {
  formatPhone,
  numberToCnpj,
  numberToCpf,
  toDate,
  toDateTime,
  toMoney,
} from '../../../../utils/formater'
import moment from 'moment'
import {useNavigate, useParams} from 'react-router-dom'
import Swal from 'sweetalert2'
import {ModalDelete} from '../../../../components/Modals/General/ModalDelete/ModalDelete'
import useModals from '../../../../hooks/useModals'
import {ModalWrapper} from '../../../../components/Modals/General/ModalWrapper/ModalWrapper'
import {KTSVG} from '../../../../../_metronic/helpers'
import useAuth from '../../../../hooks/useAuth'
import {getPlugintypeIdByCode} from '../../../../functions/plugintype'
import {i18n} from '../../../../translate/i18n'
import {centsToFloat, floatToPrice} from '../../../../functions/price'
import styles from './view.module.css'
import {GoogleMap, useJsApiLoader} from '@react-google-maps/api'
import {auto} from '@popperjs/core'
import getIntegrations from '../../../../utils/printOrder'
import {Buffer} from 'buffer'
const qz = require('qz-tray')

type CustomerAddressType = {
  city: string
  district: string
  state: string
  street: string
  zipCode: string
  number: string
  extra: string
}

type CustomerPhoneType = {
  id: number
  numberPhone: string
  typePhone: string
}

type CustomerType = {
  id: number
  name: string
  doc: string
  email: string
  birthDate: string
  customerAddresses: CustomerAddressType[]
  customerPhones: CustomerPhoneType[]
}

type LocationType = {
  id: number
  name: string
  code: string
}

type StatusType = {
  id: number
  name: string
  slug: string
  order: number
  colorSetting: {
    background: string
  }
  pluginspaceId: number
  plugintypeId: number
  externalCorrelation: Record<string, string>
  displayStatusWebapp: boolean
  messageStatus: string
  activeSms: boolean
}

type VariationType = {
  id: number
  context: string
}

type AdditionalType = {
  code: string
  name: string
  price: number
  quantity: number
}

type FractionalType = {
  name: string
}

type ProductContentType = {
  productName: string
  image?: string
  observation?: string
  additionals: AdditionalType[]
  fractionated: FractionalType[]
  measures: MeasureType | null
}

type MeasureType = {
  width: number
  height: number
  lenght: number
  weight: number
}

type ProductType = {
  id: number
  sku: string
  quantity: number
  price: number
  discount: string
  skuLocalVariation: VariationType
  variationHtml?: string
  additionalHtml?: string
  fractionalHtml?: string
  content: ProductContentType
}

type PaymentGatewayType = {
  nsu: string
}

type CaptureType = {
  AuthorizationCode?: string
}

type PaymentDataType = {
  brand: string
  nameGateway: string
  id: number
  typePay: string
  cardOperator: number
  installment: number
  installmentValue: number
}

type GatewayType = {
  bin: string
  end: string
  flagIdentifier: string
  authorization: string
  typeTicket: string
  nsu: string
  pluginconfig_id: number
  payment: PaymentGatewayType
  orderIdExt: string
  portion_numInstallments?: number
  cardTicket?: string
  ctk?: string
  paymentType?: number
  status?: string
  codePay?: string
  capture?: CaptureType
  paymentData?: PaymentDataType
}

type OtherPersonType = {
  name: string
  cpf: string
}

type FrenetType = {
  Carrier: string
  CarrierCode: string
  DeliveryTime: string
  Error: boolean
  Msg: string
  OriginalDeliveryTime: string
  OriginalShippingPrice: string
  ServiceCode: string
  ServiceDescription: string
  ShippingPrice: string
  TrackingURL?: string
  LabelURL?: string
  DeclarationURL?: string
}

type OrderAddressType = {
  address: string
  city: string
  district: string
  name: string
  number: string
  complement?: string
  state?: string
  cep?: string
  otherPersonToWithdrawal?: OtherPersonType
  frenet?: FrenetType
}

type ContentOrderType = {
  code: string
  info: string
  customer: string
  phoneSms: string
  dataGateway: GatewayType
  orderAddress: OrderAddressType
  externalCodeERP: string
  landmarkSynkarName?: string
  changeMoney?: number
  discountPaymentType?: any
  refund?: {
    refunded: boolean
    refundStatus: string
    refundAmount: number
    refundDate: string
    refundReason: string
    refundResponse?: any
  }
  hotelContext?: hotelContext
}

type OrderStatusType = {
  id: number
  created: string
  statusId: number
  status?: string
  order?: number
  color?: string
}

type OrderResponseType = {
  id: number
  deliveryTax?: string
  account?: string
  orderidExt: string
  customer: CustomerType
  created: string
  location: LocationType
  status: StatusType[]
  content: ContentOrderType
  smartOrder: ProductType[]
  orderStatus: OrderStatusType[]
  total: number
  totalWithoutDiscount: number
  statusId: number
  observation: string
  customerCart?: {
    seller: {
      name: string
      email: string
      cpf: string
    }
  }
}

type ClearsaleResponseType = {
  code: string
  status: string
  score: number
}

interface coupomOrder {
  id: number
  couponId: number
  customerId: number
  pluginspaceId: number
  orderId: number
  created: string
  updated: string
  discountCoupons: DiscountCoupons
}

interface DiscountCoupons {
  id: number
  nameCoupom: string
  description: string
  typeCupom: string
  pluginspaceId: number
  valueDiscount: string
  percentageDiscount: string
  usageQuantity: number
  daysValidity: null
  startDate: string
  endDate: string
  created: string
  updated: string
  deleted: null
  status: boolean
  idCatalog: null
  sellerId: number
}

interface hotelContext {
  doc: string
  id: number
  pluginspaceId: string
  roomId: number
}

const libraries: ('drawing' | 'geometry' | 'localContext' | 'places' | 'visualization')[] = [
  'visualization',
]

const PedidosViewContent: FC = () => {
  const navigate = useNavigate()
  const {wrapperModal, showWrapperModal, closeWrapperModal} = useModals()
  const {id} = useParams()
  const [loading, setLoading] = useState(false)
  const [order, setOrder] = useState<OrderResponseType | null>(null)
  const [statusSelected, setStatusSelected] = useState(0)
  const [statusOptions, setStatusOptions] = useState<any[]>([])
  const {loginInfo} = useAuth()
  const [clearsaleOrder, setClearsaleOrder] = useState<ClearsaleResponseType | null>(null)
  const [heightClient, setHeightClient] = useState('14em')
  const [heightPayment, setHeightPayment] = useState('15.5em')
  const [heightOrder, setHeightOrder] = useState('26.5em')
  const [center, setCenter] = useState([-22.910279297298477, -43.18973555700653])
  const [balance, setBalance] = useState(0)
  const [modalToShow, setModalToShow] = useState<
    'status' | 'balance' | 'measures' | 'print' | 'refund'
  >('status')
  const [height, setHeight] = useState(0)
  const [width, setWidth] = useState(0)
  const [length, setLength] = useState(0)
  const [weight, setWeight] = useState(0)
  const [declaredValue, setDeclaredValue] = useState(false)
  const [serviceFinded, setServiceFinded] = useState<FrenetType | null>()
  const [loadingFrenet, setLoadingFrenet] = useState(false)
  const [loadingStatus, setLoadingStatus] = useState(false)
  const [defaultDeep, setDefaultDeep] = useState(0)
  const [defaultHeight, setDefaultHeight] = useState(0)
  const [defaultWeight, setDefaultWeight] = useState(0)
  const [defaultWidth, setDefaultWidth] = useState(0)
  const {isLoaded} = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: process.env.REACT_APP_MAPS_KEY ? process.env.REACT_APP_MAPS_KEY : '',
    libraries: libraries,
  })
  const [isPrinting, setIsPrinting] = useState(false)
  const [resultPrint, setResultPrint] = useState<{success: boolean; message: string} | null>(null)
  const [canPrint, setCanPrint] = useState(false)
  const [codigoPedido, setCodigoPedido] = useState('')

  const [hotelContext, setHotelContext] = useState<hotelContext | null>(null)

  const [discountPaymentType, setDiscountPaymentType] = useState<{
    discountValue: string
    type: string
  } | null>()

  const [discountCoupom, setDiscountCoupom] = useState<coupomOrder>()

  const getClearsaleOrder = async (newOrder: OrderResponseType, shouldLoad?: boolean) => {
    try {
      shouldLoad && setLoading(true)
      const resClearsale = await POST('analyzeorder/searchOrderStatusClearSale', {
        orderId: parseInt(id ? id : '0'),
        order: newOrder.orderidExt ? newOrder.orderidExt : '',
        pluginspaceId: loginInfo.pluginspaceId,
        plugintypeId: getPlugintypeIdByCode(loginInfo.plugintype),
      })
      shouldLoad && setLoading(false)

      if (resClearsale.success) {
        setClearsaleOrder(resClearsale.data)
      } else {
        setClearsaleOrder(null)
      }
    } catch (e) {
      shouldLoad && setLoading(false)
      setClearsaleOrder(null)
      console.log(e)
    }
  }

  const getOrder = async () => {
    try {
      wrapperModal.title = 'Alterar status do pedido'
      setLoading(true)
      const resOrders =
        loginInfo.plugintype === 'hospitality'
          ? await POST('/orders/get-order-all-info-hotel', {orderId: id})
          : await POST('/orders/get-order-all-info-v2', {orderId: id})
      // Executar as requisições em paralelo para otimizar o tempo
      const [resGMT] = await Promise.all([
        GET(`pluginspace/${loginInfo.pluginspaceId}`),
        getCupom(),
        getStatus(),
      ])

      const gmt = resGMT.data[0].gmt
      let newOrder: OrderResponseType = resOrders.data[0]
      let total = 0
      let totalWithoutDiscount = 0
      setStatusSelected(newOrder.statusId)
      await getClearsaleOrder(newOrder)
      newOrder.smartOrder.forEach((product) => {
        if (product.skuLocalVariation) {
          const html = Object.entries(JSON.parse(product.skuLocalVariation.context)).map(
            (variation: any) => {
              if (
                variation[0].toLocaleLowerCase() !== 'variation' &&
                variation[1].toLocaleLowerCase() !== 'none'
              ) {
                return `<p class='mb-0'>${variation[0]}: ${variation[1]}</p>`
              } else {
                return ``
              }
            }
          )
          product.variationHtml = html.join('')
        }

        if (
          product.content &&
          product.content.additionals &&
          product.content.additionals.length > 0
        ) {
          let htmlAdditional = ''
          product.content.additionals.forEach((additional) => {
            htmlAdditional += `<p class='mb-0'>${additional.quantity}X ${
              additional.name
            } (${floatToPrice(centsToFloat(additional.price))})</p>`
            product.additionalHtml = htmlAdditional
            product.price += additional.price * additional.quantity
          })
        }

        if (
          product.content &&
          product.content.fractionated &&
          product.content.fractionated.length > 0
        ) {
          let htmlFractional = ''
          product.content.fractionated.forEach((fractional) => {
            htmlFractional += `<p class='mb-0'>${fractional.name}</p>`
            product.fractionalHtml = htmlFractional
          })
        }

        total += product.price * product.quantity
        totalWithoutDiscount += (parseFloat(product.discount) + product.price) * product.quantity
      })

      if (newOrder.content && newOrder.content.discountPaymentType) {
        const discountPaymentType = newOrder.content.discountPaymentType
        if (discountPaymentType.type === 'percentage') {
          total = total - (total * parseFloat(discountPaymentType.discountValue)) / 100
        } else {
          total = total - parseFloat(discountPaymentType.discountValue) * 100
        }
        setDiscountPaymentType(discountPaymentType)
      }

      newOrder.total = total
      newOrder.totalWithoutDiscount = totalWithoutDiscount
      newOrder.orderStatus.map((status, index) => {
        if (index > 0) {
          const dateFormated = new Date(status.created)

          dateFormated.setHours(dateFormated.getHours() + parseInt(gmt))

          // Formatar a data com o GMT especificado
          status.created = dateFormated.toISOString()
        }

        const findedStatus = newOrder.status.find((st) => st.id === status.statusId)
        if (findedStatus) {
          status.status = findedStatus.name
          status.order = findedStatus.order
          switch (findedStatus.order) {
            case 1:
              status.color = '#4DD0E1'
              break
            case 2:
              status.color = '#8D6E63'
              break
            case 3:
              status.color = '#7E57C2'
              break
            case 4:
              status.color = '#2E7D32'
              break
            default:
              status.color = '#AD1457'
              break
          }
        }
      })
      if (
        newOrder &&
        newOrder.content &&
        newOrder.content.orderAddress &&
        newOrder.content.orderAddress.frenet
      ) {
        const resultFrenet: any = newOrder.content.orderAddress.frenet
        if (resultFrenet.result && resultFrenet.result.items && resultFrenet.result.items[0]) {
          newOrder.content.orderAddress.frenet.TrackingURL =
            resultFrenet.result.items[0].trackingUrl
          newOrder.content.orderAddress.frenet.LabelURL = resultFrenet.result.items[0].labelUrl
          newOrder.content.orderAddress.frenet.DeclarationURL =
            resultFrenet.result.items[0].declarationUrl
        }
      }
      await getCenter(
        newOrder &&
          newOrder.content &&
          newOrder.content.orderAddress &&
          newOrder.content.orderAddress.cep
          ? newOrder.content.orderAddress.cep
          : ''
      )

      const codigoPedido =
        newOrder.content && newOrder.content.externalCodeERP
          ? `${newOrder.content.externalCodeERP}`
          : newOrder.id

      setCodigoPedido(codigoPedido.toString())

      const notAllowedTypeTickets = ['payOffline', 'offline', 'offline_payment', 'pix']
      const gatewayData = newOrder.content.dataGateway

      const hasValidOrder = !!newOrder
      const isRefundableTicketType = !notAllowedTypeTickets.includes(gatewayData.typeTicket)
      const hasNoExistingRefund = !newOrder?.content.refund
      setCanBeRefunded(hasValidOrder && isRefundableTicketType && hasNoExistingRefund)
      setHasBeenRefunded(!hasNoExistingRefund)

      setOrder(newOrder)

      setHotelContext(newOrder.content.hotelContext ? newOrder.content.hotelContext : null)

      getHeights()
      setLoading(false)
    } catch (e) {
      getHeights()
      setLoading(false)
      Swal.fire({
        icon: 'warning',
        title: 'Atenção',
        text: 'Falha ao buscar pedido',
      }).then(() => navigate('/order/saleorder'))
    }
  }
  const getStatus = async () => {
    try {
      setLoading(true)
      const statusRes = await GET('/status')
      const newStatusOptions = statusRes.data
        .filter((status: StatusType) => status.displayStatusWebapp === true)
        .map((statusItem: StatusType) => ({
          value: parseInt(statusItem.id.toString()),
          select: statusItem.name,
        }))
      setStatusOptions([...statusOptions, ...newStatusOptions])
    } catch (e) {
      console.log(e)
    }
  }

  const getCupom = async () => {
    try {
      const getInfoCupon = await POST(`discount-coupons-customer/filterCouponsCustomerCoupom`, {
        orderId: id,
      })

      if (getInfoCupon.success) {
        setDiscountCoupom(getInfoCupon.data[0])
      }
    } catch (error) {
      console.log(error)
    }
  }

  const saveOrder = async () => {
    try {
      if (order?.statusId !== statusSelected) {
        const findedStatus = order?.status.find((st) => st.id === statusSelected)
        const resOrders = await PUT(`/orders/change-status/${id}`, {
          statusId: statusSelected,
          dataGateway: order?.content.dataGateway,
          gatewayId: order?.content.dataGateway.pluginconfig_id,
          statusSlug: findedStatus ? findedStatus.slug : '',
        })
        if (resOrders.success) {
          setOrder((prevOrder) => {
            if (!prevOrder) return prevOrder

            return {
              ...prevOrder,
              statusId: statusSelected,
            }
          })
          Swal.fire({
            icon: 'success',
            title: 'Sucesso!',
            text: 'Pedido atualizado com sucesso!',
          })
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Erro',
            text: 'Falha ao atualizar status do pedido.',
          })
        }
      } else {
        Swal.fire({
          icon: 'warning',
          title: 'Atenção!',
          text: 'Esse status já está atualizado.',
        })
      }
    } catch (e: any) {
      setLoading(false)
      Swal.fire({
        icon: 'error',
        title: 'Erro',
        text: e ? e : 'Falha ao atualizar status do pedido.',
      })
      console.log(e)
    } finally {
      setLoadingStatus(false)
    }
  }

  const formatCard = (card: string) => {
    const cardEnd = card.substring(card.length - 4, card.length)
    return `****.****.****.${cardEnd}`
  }

  const formatStatusPayment = (statusPayment: string) => {
    switch (statusPayment) {
      case 'Operation Successful':
        return 'Aprovado'
      default:
        return statusPayment
    }
  }

  const getHeightDiv = (div: string, defaultValue: string) => {
    const divFind = document.getElementById(div)
    if (divFind) {
      return `${divFind.clientHeight}px`
    }
    return defaultValue
  }

  const getHeights = () => {
    setHeightClient(getHeightDiv('card-status', '14em'))
    setHeightPayment(getHeightDiv('card-delivery', '15.5em'))
    setHeightOrder(getHeightDiv('card-product', '26.5em'))
  }

  const getCenter = async (cep: string) => {
    if (cep) {
      const latLngRes = await GET(`maps/postcode/${cep}`)
      if (
        latLngRes &&
        latLngRes.data &&
        latLngRes.data.geometry &&
        latLngRes.data.geometry.location
      ) {
        setCenter([latLngRes.data.geometry.location.lat, latLngRes.data.geometry.location.lng])
      }
    }
  }

  const calculateTimeDays = (days: string) => {
    const daysInt = parseInt(days)
    if (order?.created) {
      let timeOrder = new Date(order.created).getTime()
      timeOrder += daysInt * 24 * 60 * 60 * 1000
      const datePlus = new Date(timeOrder)
      return toDate(datePlus.toISOString())
    }
    return order?.created
  }

  async function getConfigFrenet() {
    try {
      const resValues = await POST('/pluginconfig/filter', {
        plugintemplateId: 119,
      })
      const config = resValues.data.filter(
        (el: any) =>
          el.content?.deep && el.content?.height && el.content?.weight && el.content?.width
      )
      if (config.length > 0) {
        setDefaultDeep(config[0].content.deep)
        setDefaultHeight(config[0].content.height)
        setDefaultWeight(config[0].content.weight)
        setDefaultWidth(config[0].content.width)
      }
    } catch (error) {
      console.log(error)
    }
  }

  const posCotationFrenet = async () => {
    try {
      if (!order) {
        Swal.fire({
          icon: 'error',
          title: 'Erro',
          text: 'Não foi possível encontrar pedido',
        })
        return
      }
      setLoadingFrenet(true)
      let measures = {
        Height: 0,
        Length: 0,
        Quantity: 1,
        Weight: 0,
        Width: 0,
      }
      let shipmentInvoiceValue = 0
      order.smartOrder.forEach((prod) => {
        if (prod.content.measures) {
          measures.Height += prod.content.measures.height || Number(defaultHeight)
          measures.Length += prod.content.measures.lenght || Number(defaultDeep)
          measures.Weight += prod.content.measures.weight || Number(defaultWeight)
          measures.Width += prod.content.measures.width || Number(defaultWidth)
        }
      })
      shipmentInvoiceValue =
        (order.total + parseFloat(order.deliveryTax ? order.deliveryTax : '0')) / 100
      const resFrenet = await POST('frenet/pos-quote', {
        recipientCep: order.content.orderAddress.cep,
        shipmentInvoiceValue,
        shippingItemArray: [measures],
        declaredValue,
        recipientCountry: 'BR',
      })
      setLoadingFrenet(false)
      if (
        resFrenet.success &&
        resFrenet.data &&
        resFrenet.data.ShippingSevicesArray &&
        order.content.orderAddress.frenet
      ) {
        const findedShippingService = resFrenet.data.ShippingSevicesArray.find(
          (service: FrenetType) =>
            service.ServiceCode === order.content.orderAddress.frenet?.ServiceCode
        )
        if (findedShippingService) {
          setServiceFinded(findedShippingService)
        } else {
          closeWrapperModal()
          Swal.fire({
            icon: 'error',
            title: 'Erro',
            text: 'Falha ao encontrar cotação',
          })
        }
      } else {
        closeWrapperModal()
        Swal.fire({
          icon: 'error',
          title: 'Erro',
          text: 'Falha ao realizar pós cotação',
        })
      }
    } catch (e: any) {
      console.log(e)
      setLoadingFrenet(false)
      closeWrapperModal()
      Swal.fire({
        icon: 'error',
        title: 'Erro',
        text: e ? e : 'Falha ao realizar pós cotação.',
      })
    }
  }

  const printLabel = async () => {
    if (!serviceFinded) {
      Swal.fire({
        icon: 'error',
        title: 'Erro',
        text: 'Falha ao encontrar serviço de etiqueta',
      })
      return
    }
    const serviceFindedStorage = {...serviceFinded}
    closeWrapperModal()
    setServiceFinded(undefined)
    setHeight(0)
    setWidth(0)
    setLength(0)
    setWeight(0)
    try {
      setLoading(true)
      if (order) {
        const resFrenet = await POST('frenet/print', {
          order: {
            id: id,
            declaredValue,
            value: (order.total + parseFloat(order.deliveryTax ? order.deliveryTax : '0')) / 100,
            created: order.created,
            items: order.smartOrder.map((item) => {
              return {
                productId: item.id.toString(),
                productName: item.content.productName,
                orderId: order.id.toString(),
                weight: item.content.measures ? item.content.measures.weight : null,
                length: item.content.measures ? item.content.measures.lenght : null,
                height: item.content.measures ? item.content.measures.height : null,
                width: item.content.measures ? item.content.measures.width : null,
                quantity: item.quantity,
                price: item.price,
              }
            }),
            to: {
              name: order.customer.name,
              document: order.customer.doc,
              address: {
                zipCode: order.content.orderAddress.cep,
                city: order.content.orderAddress.city,
                street: order.content.orderAddress.address,
                addressNumber: order.content.orderAddress.number,
                addressQuarter: order.content.orderAddress.district,
                addressState: order.content.orderAddress.state,
                country: 'BR',
              },
            },
          },
          volumes: {
            weight,
            length,
            height,
            width,
          },
          quotation: serviceFindedStorage,
        })
        setLoading(false)

        if (resFrenet.success) {
          Swal.fire({
            icon: 'success',
            title: 'Sucesso!',
            text: 'Etiqueta impressa com sucesso',
          }).then(async () => await getOrder())
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Erro',
            text: 'Falha ao imprimir etiqueta',
          })
        }
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Erro',
          text: 'Falha ao encontrar pedido',
        })
      }
    } catch (e: any) {
      console.log(e)
      setLoading(false)
      if (typeof e === 'string' && e.toLowerCase().includes('saldo insuficiente')) {
        await getBalance()
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Erro',
          text: e ? e : 'Falha ao imprimir etiqueta.',
        })
      }
    }
  }

  const getBalance = async () => {
    try {
      setLoading(true)
      const walletRes = await GET(`frenet/wallet`)
      setLoading(false)
      if (walletRes && walletRes.data && walletRes.data.balance) {
        setBalance(walletRes.data.balance)
        setModalToShow('balance')
        showWrapperModal(i18n.t(`frenet.no_balance`))
      }
    } catch (e) {
      setLoading(false)
      console.log(e)
    }
  }

  const getTrackingCode = (url: string) => {
    const urlSplit = url.split('/')
    return urlSplit[urlSplit.length - 1]
  }

  const getStatusPrinter = async () => {
    const integrations = await getIntegrations(loginInfo)
    let statusPrint

    if (integrations.length === 0 || integrations[0].data[0].content.enabled === '0') {
      setCanPrint(false)
    } else {
      setCanPrint(true)
    }
  }

  const connectQZ = () => {
    return new Promise((resolve, reject) => {
      qz.websocket
        .connect()
        .then(() => resolve('Conectado ao QZ Tray'))
        .catch((error: any) => reject(`Erro na conexão com QZ Tray: ${error}`))
    })
  }

  const printOrder = async () => {
    setIsPrinting(true)
    setResultPrint(null)

    try {
      const res = await getIntegrations(loginInfo)

      if (!order?.id) throw new Error('Pedido é nulo ou não possui um ID')

      if (res[0].data[0].content.printer_model) {
        const print = await POST('order-printer/print-order', {
          orderId: order?.id,
        })

        if (print.success === true) {
          setResultPrint({success: true, message: print.message})
        } else {
          setResultPrint({success: false, message: print.message})
        }

        const dataBuffer = Buffer.from(print.data, 'utf8')
        const dataToSend = dataBuffer.toString('utf8')

        await connectQZ()

        // Executar a impressão
        qz.printers
          .find(res[0].data[0].content.printer_model)
          .then((printer: any) => {
            const config = qz.configs.create(printer)
            const data = [
              '\x1B\x40', // Inicializa a impressora
              dataToSend,
              '\x1D\x56\x00', // Comando para cortar
            ]
            return qz.print(config, data)
          })
          .then(() => {
            setResultPrint({success: true, message: 'Solicitação enviada com sucesso'})
          })
          .catch((error: any) => {
            setResultPrint({success: false, message: 'Impressora não encontrada.'})
          })
          .finally(() => {
            qz.websocket.disconnect()
          })
      } else {
        setResultPrint({success: false, message: 'Nenhuma impressora foi encontrada'})
      }
    } catch (e) {
      console.log(e)
      setResultPrint({success: false, message: 'Erro na impressão. Tente novamente.'})
    } finally {
      setIsPrinting(false)
    }
  }

  const getPaymentType = (type: string) => {
    switch (type.toLowerCase()) {
      case 'credit':
        return i18n.t('payment.card') + ' - '
      case 'debit':
        return i18n.t('payment.debit') + ' - '
      default:
        return ''
    }
  }

  useEffect(() => {
    getConfigFrenet()
    getOrder()
    getStatusPrinter()
  }, [])

  /*Usado para Estorno de pagamento */
  const canRefund = (createdDate: string): boolean => {
    const thirtyDaysAgo = moment().subtract(30, 'days')
    const orderDate = moment(createdDate)
    return orderDate.isAfter(thirtyDaysAgo)
  }

  const [canBeRefunded, setCanBeRefunded] = useState(false)
  const [hasBeenRefunded, setHasBeenRefunded] = useState(false)
  const [refundLoading, setRefundLoading] = useState(false)
  const [showTooltip, setShowTooltip] = useState(false)

  const handleRefund = async () => {
    try {
      setRefundLoading(true)

      const refundResponse = await POST('/orders/refund-order', {
        orderId: order?.id,
        gatewayData: order?.content.dataGateway,
        amount: (order?.total ?? 0) + parseFloat(order?.deliveryTax ?? '0'),
        reason: 'Estorno solicitado pelo cliente',
      })

      if (refundResponse.success) {
        Swal.fire({
          icon: 'success',
          title: 'Sucesso!',
          text: 'Estorno realizado com sucesso!',
          customClass: {
            container: `${styles.swalContainer}`,
          },
        }).then(() => {
          closeWrapperModal()
          getOrder() // Recarrega os dados do pedido
        })
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Erro',
          text: refundResponse.message || 'Falha ao realizar estorno',
          customClass: {
            container: `${styles.swalContainer}`,
          },
        }).then(() => {
          closeWrapperModal()
        })
      }
    } catch (error: any) {
      console.error('Erro no estorno:', error)
      Swal.fire({
        icon: 'error',
        title: 'Erro',
        text: error || 'Falha ao realizar estorno',
        customClass: {
          container: `${styles.swalContainer}`,
        },
      }).then(() => {
        closeWrapperModal()
      })
    } finally {
      setRefundLoading(false)
    }
  }

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <div className='row g-5 gx-xxl-12'>
          {order && (
            <div className='d-flex flex-row justify-content-between gap-10 flex-wrap'>
              <div className='d-flex flex-column' style={{width: 'calc(50% - 2.5rem)'}}>
                <div className='card mb-5' id='card-status' style={{minHeight: '14em'}}>
                  <div className='card-header py-5 d-flex justify-content-between align-items-center'>
                    <h3 className='card-title align-items-start flex-column'>
                      <span className='card-label fw-bolder fs-3 mb-1'>
                        {i18n.t(`reports.order`)} #{codigoPedido}
                      </span>
                    </h3>
                    {canPrint && (
                      // <span
                      //   className='d-flex align-items-center mt-0 mb-0 gap-3'
                      //   onClick={() => {
                      //     setModalToShow('print')
                      //     showWrapperModal('Imprimir pedido')
                      //   }}
                      //   style={{cursor: 'pointer', padding: 0, color: '#6e7586', fontWeight: 400}}
                      // >
                      //   <p style={{margin: 0, padding: 0}}>Imprimir</p>
                      //   <i
                      //     className='fas fa-print'
                      //     style={{fontSize: '16px', margin: 0, padding: 0}}
                      //   ></i>
                      // </span>
                      <Button
                        color='primary'
                        icon='fa fa-print' // Ícone de impressão
                        text={i18n.t(`order_print.print_text`)} // Texto do botão
                        click={() => {
                          setModalToShow('print')
                          showWrapperModal(
                            `${i18n.t('order_print.print')} ${' #'}${order?.id || ''}`
                          )
                        }}
                      />
                    )}
                  </div>
                  <div className='card-body'>
                    <div className={`${styles.cardStatus}`}>
                      <h3 className={`mt-6`}>Status</h3>
                      <div className='d-flex flex-row gap-4 align-items-end'>
                        <Input
                          inputAttr={{
                            type: 'select',
                          }}
                          label=''
                          options={statusOptions}
                          value={statusSelected}
                          change={(value: string) => setStatusSelected(parseInt(value))}
                        />
                        <Button
                          color='primary'
                          text={i18n.t(`buttons.save`)}
                          loading={loadingStatus}
                          disabled={!order.content ? true : false || loadingStatus}
                          btnClass='h-40px d-flex flex-row align-items-center'
                          click={() => {
                            setLoadingStatus(true)
                            setModalToShow('status')
                            if (!order.content) {
                              Swal.fire({
                                icon: 'warning',
                                title: 'Atenção!',
                                text: 'Impossível alterar status desse pedido',
                              })
                              setLoadingStatus(false)
                            } else if (order?.statusId && statusSelected < order?.statusId) {
                              showWrapperModal('Alterar status do pedido')
                            } else {
                              saveOrder()
                            }
                          }}
                        />
                      </div>
                    </div>
                    <div className={`${styles.cardStatus} mt-6`}>
                      <h3>{i18n.t(`reports.external_code`)}</h3>
                      <p>{order.orderidExt}</p>
                    </div>
                    <div className={`${styles.cardStatus} mt-4`}>
                      <h3>{i18n.t(`reports.date`)}</h3>
                      <p>{toDateTime(order.created)}</p>
                    </div>
                    {order?.customerCart?.seller && (
                      <div className='d-flex flex-row align-items-center mt-4'>
                        <div className={`${styles.cardStatus}`}>
                          <h3>{i18n.t(`reports.origin`)}</h3>
                          <div className='d-flex flex-row align-items-center gap-4 w-100'>
                            <p>{i18n.t(`reports.seller_link`)}</p>
                            <h3>{i18n.t(`reports.seller`)}</h3>
                            <p>{order.customerCart.seller.name}</p>
                          </div>
                        </div>
                      </div>
                    )}
                    {hotelContext && (
                      <div className='mt-4'>
                        <b>{i18n.t('reports.hotel')}</b>

                        <div className='mt-2'>
                          <div className='row mb-2'>
                            <div className='col-12 col-md-4 text-muted small'>
                              {i18n.t('reports.id')}
                            </div>
                            <div className='col-12 col-md-8 fw-semibold'>{hotelContext.id}</div>
                          </div>

                          <div className='row mb-2'>
                            <div className='col-12 col-md-4 text-muted small'>
                              {i18n.t('reports.pluginspace')}
                            </div>
                            <div className='col-12 col-md-8 fw-semibold'>
                              {hotelContext.pluginspaceId}
                            </div>
                          </div>

                          <div className='row mb-2'>
                            <div className='col-12 col-md-4 text-muted small'>
                              {i18n.t('reports.document')}
                            </div>
                            <div className='col-12 col-md-8 fw-semibold'>
                              {hotelContext.doc &&
                                (hotelContext.doc.length <= 11
                                  ? numberToCpf(hotelContext.doc)
                                  : numberToCnpj(hotelContext.doc))}
                            </div>
                          </div>

                          <div className='row mb-2'>
                            <div className='col-12 col-md-4 text-muted small'>
                              {i18n.t('reports.room')}
                            </div>
                            <div className='col-12 col-md-8 fw-semibold'>{hotelContext.roomId}</div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                {/* {order?.customerCart?.seller &&
                  <div className='card'>
                    <div className='card-header py-5'>
                      <h3 className='card-title align-items-start flex-column'>
                        <span className='card-label fw-bolder fs-3 mb-1'>{i18n.t(`reports.seller`)}</span>
                      </h3>
                    </div>
                    <div className='card-body'>
                      <div>
                        <p className='mb-0'>
                          <b>{order?.customerCart?.seller.name}</b>
                        </p>
                        {order?.customerCart?.seller.email && (
                          <p className='mb-0'>
                            Email: {order.customerCart?.seller.email}
                          </p>
                        )}
                        {order?.customerCart?.seller.cpf && (
                          <p className='mb-0'>CPF: {numberToCpf(order.customerCart?.seller.cpf)}</p>
                        )}

                      </div>
                    </div>
                  </div>
                } */}

                {order.content && (
                  <div className='card mb-5' id='card-delivery' style={{minHeight: '15.5em'}}>
                    <div className='card-header py-5'>
                      <h3 className='card-title align-items-start flex-column'>
                        {order.content.code === 'synkar' && order.content.landmarkSynkarName ? (
                          <span className='card-label fw-bolder fs-3 mb-1'>
                            {`${order.location.name}`}
                          </span>
                        ) : (
                          <span className='card-label fw-bolder fs-3 mb-1'>
                            {`${i18n.t(`reports.modality`)}: ${i18n.t(
                              `reports.${order?.content.code.replace(/-.*/, '')}`
                            )}`}
                          </span>
                        )}
                      </h3>
                    </div>
                    <div className='card-body'>
                      {order.content && order.content.orderAddress && (
                        <>
                          <div className={styles.gridDelivery}>
                            <div>
                              {order.content.code === 'withdraw' && (
                                <div className='mb-4'>
                                  <p className='mb-0'>
                                    <b>{i18n.t(`reports.responsible_withdraw`)}</b>
                                  </p>
                                  <p className='mb-0'>{order.customer.name}</p>
                                  <p className='mb-0'>
                                    {order.customer.doc.length <= 11
                                      ? `CPF: ${numberToCpf(order.customer.doc)}`
                                      : `CNPJ: ${numberToCnpj(order.customer.doc)}`}
                                  </p>
                                </div>
                              )}
                              <p className='mb-0'>
                                <b>
                                  {order.content.code === 'withdraw' ||
                                  order.content.code === 'table'
                                    ? i18n.t(`reports.address_withdraw`)
                                    : i18n.t(`reports.address_delivery`)}
                                </b>
                              </p>
                              {order.content.code === 'internal-delivery' ? (
                                <p className='mb-0'>
                                  {`${
                                    order.content.orderAddress.complement
                                      ? order.content.orderAddress.complement
                                      : ''
                                  }`}
                                </p>
                              ) : order.content.code === 'synkar' ? (
                                <>
                                  <p className='mb-0'>{order.content.landmarkSynkarName}</p>
                                </>
                              ) : (
                                <>
                                  <p className='mb-0'>{order.content.orderAddress.name}</p>
                                  <p className='mb-0'>
                                    {`${order.content.orderAddress.address} ${
                                      order.content.orderAddress.number
                                        ? ', ' + order.content.orderAddress.number
                                        : ''
                                    }`}
                                  </p>
                                  <p className='mb-0'>
                                    {order.content.orderAddress.cep &&
                                      `
                                              ${order.content.orderAddress.city} 
                                              ${
                                                order.content.orderAddress.state
                                                  ? ' - ' + order.content.orderAddress.state
                                                  : ''
                                              }
                                              ${
                                                order.content.orderAddress.cep.substring(0, 5) +
                                                '-' +
                                                order.content.orderAddress.cep.substring(5, 8)
                                              }
                                              `}
                                  </p>
                                </>
                              )}
                            </div>
                            {order.content.code.split('-')[0] === 'delivery' && (
                              <div className={styles.gridMap}>
                                {isLoaded && (
                                  <GoogleMap
                                    mapContainerStyle={{
                                      width: '100%',
                                      height: '180px',
                                    }}
                                    center={new google.maps.LatLng(center[0], center[1])}
                                    zoom={15}
                                    mapTypeId={google.maps.MapTypeId.ROADMAP}
                                  ></GoogleMap>
                                )}
                              </div>
                            )}
                          </div>
                          {order.content.orderAddress.frenet && (
                            <>
                              <div className={styles.gridFrenet}>
                                <b>{i18n.t(`reports.send_method`)}</b>
                                <p>
                                  Frenet -{' '}
                                  {order.content.orderAddress.frenet.ServiceDescription
                                    ? order.content.orderAddress.frenet.ServiceDescription
                                    : order.content.orderAddress.frenet.Carrier}
                                </p>
                              </div>
                              {/* <div className={styles.gridFrenet}>
                                <b>{i18n.t(`reports.send_date`)}</b>
                                <p></p>
                              </div> */}
                              <div className={styles.gridFrenet}>
                                <b>{i18n.t(`reports.estimated_delivery`)}</b>
                                <p>
                                  {calculateTimeDays(
                                    order.content.orderAddress.frenet.DeliveryTime
                                  )}
                                </p>
                              </div>
                              <div className={styles.gridFrenet}>
                                <b>{i18n.t(`reports.freight`)}</b>
                                <p>
                                  {floatToPrice(
                                    parseFloat(order.content.orderAddress.frenet.ShippingPrice)
                                  )}
                                </p>
                              </div>
                              {order.content.orderAddress.frenet.TrackingURL && (
                                <div className={styles.gridFrenet}>
                                  <b>{i18n.t(`reports.tracking_code`)} </b>
                                  {order.content.orderAddress.frenet.TrackingURL && (
                                    <div className='d-flex flex-row gap-2'>
                                      <p style={{marginTop: '0.2rem'}}>
                                        {getTrackingCode(
                                          order.content.orderAddress.frenet.TrackingURL
                                        )}
                                      </p>
                                      <p style={{textWrap: 'nowrap'}}>
                                        <a
                                          href={order.content.orderAddress.frenet.TrackingURL}
                                          target='_blank'
                                        >
                                          {i18n.t(`reports.website`)}
                                          <svg
                                            className='m-2'
                                            width='12'
                                            height='13'
                                            viewBox='0 0 12 13'
                                            fill='none'
                                            xmlns='http://www.w3.org/2000/svg'
                                          >
                                            <path
                                              d='M7.125 1.0625C7.125 0.757812 7.35938 0.5 7.6875 0.5H11.4141C11.7422 0.5 11.9766 0.757812 11.9766 1.0625V4.8125C11.9766 5.14062 11.7422 5.375 11.4141 5.375C11.1094 5.375 10.8516 5.14062 10.8516 4.8125V2.42188L5.625 7.64844C5.41406 7.88281 5.0625 7.88281 4.85156 7.64844C4.61719 7.4375 4.61719 7.08594 4.85156 6.85156L10.0781 1.625H7.6875C7.35938 1.625 7.125 1.39062 7.125 1.0625ZM1.6875 1.25H4.6875C4.99219 1.25 5.25 1.50781 5.25 1.8125C5.25 2.14062 4.99219 2.375 4.6875 2.375H1.6875C1.35938 2.375 1.125 2.63281 1.125 2.9375V10.8125C1.125 11.1406 1.35938 11.375 1.6875 11.375H9.5625C9.86719 11.375 10.125 11.1406 10.125 10.8125V7.8125C10.125 7.50781 10.3594 7.25 10.6875 7.25C10.9922 7.25 11.25 7.50781 11.25 7.8125V10.8125C11.25 11.75 10.4766 12.5 9.5625 12.5H1.6875C0.75 12.5 0 11.75 0 10.8125V2.9375C0 2.02344 0.75 1.25 1.6875 1.25Z'
                                              fill='#3C9EE6'
                                            />
                                          </svg>
                                        </a>
                                      </p>
                                    </div>
                                  )}
                                </div>
                              )}
                              {order.content.orderAddress.frenet.LabelURL && (
                                <div className={styles.gridFrenet}>
                                  <b>{i18n.t(`reports.label_code`)} </b>
                                  {order.content.orderAddress.frenet.LabelURL && (
                                    <p style={{textWrap: 'nowrap'}}>
                                      <a
                                        href={order.content.orderAddress.frenet.LabelURL}
                                        target='_blank'
                                      >
                                        {i18n.t(`reports.label_website`)}
                                        <svg
                                          className='m-2'
                                          width='12'
                                          height='13'
                                          viewBox='0 0 12 13'
                                          fill='none'
                                          xmlns='http://www.w3.org/2000/svg'
                                        >
                                          <path
                                            d='M7.125 1.0625C7.125 0.757812 7.35938 0.5 7.6875 0.5H11.4141C11.7422 0.5 11.9766 0.757812 11.9766 1.0625V4.8125C11.9766 5.14062 11.7422 5.375 11.4141 5.375C11.1094 5.375 10.8516 5.14062 10.8516 4.8125V2.42188L5.625 7.64844C5.41406 7.88281 5.0625 7.88281 4.85156 7.64844C4.61719 7.4375 4.61719 7.08594 4.85156 6.85156L10.0781 1.625H7.6875C7.35938 1.625 7.125 1.39062 7.125 1.0625ZM1.6875 1.25H4.6875C4.99219 1.25 5.25 1.50781 5.25 1.8125C5.25 2.14062 4.99219 2.375 4.6875 2.375H1.6875C1.35938 2.375 1.125 2.63281 1.125 2.9375V10.8125C1.125 11.1406 1.35938 11.375 1.6875 11.375H9.5625C9.86719 11.375 10.125 11.1406 10.125 10.8125V7.8125C10.125 7.50781 10.3594 7.25 10.6875 7.25C10.9922 7.25 11.25 7.50781 11.25 7.8125V10.8125C11.25 11.75 10.4766 12.5 9.5625 12.5H1.6875C0.75 12.5 0 11.75 0 10.8125V2.9375C0 2.02344 0.75 1.25 1.6875 1.25Z'
                                            fill='#3C9EE6'
                                          />
                                        </svg>
                                      </a>
                                    </p>
                                  )}
                                </div>
                              )}
                              {order.content.orderAddress.frenet.DeclarationURL && (
                                <div className={styles.gridFrenet}>
                                  <b>{i18n.t(`reports.declaration_code`)} </b>
                                  {order.content.orderAddress.frenet.DeclarationURL && (
                                    <p style={{textWrap: 'nowrap'}}>
                                      <a
                                        href={order.content.orderAddress.frenet.DeclarationURL}
                                        target='_blank'
                                      >
                                        {i18n.t(`reports.declaration_website`)}
                                        <svg
                                          className='m-2'
                                          width='12'
                                          height='13'
                                          viewBox='0 0 12 13'
                                          fill='none'
                                          xmlns='http://www.w3.org/2000/svg'
                                        >
                                          <path
                                            d='M7.125 1.0625C7.125 0.757812 7.35938 0.5 7.6875 0.5H11.4141C11.7422 0.5 11.9766 0.757812 11.9766 1.0625V4.8125C11.9766 5.14062 11.7422 5.375 11.4141 5.375C11.1094 5.375 10.8516 5.14062 10.8516 4.8125V2.42188L5.625 7.64844C5.41406 7.88281 5.0625 7.88281 4.85156 7.64844C4.61719 7.4375 4.61719 7.08594 4.85156 6.85156L10.0781 1.625H7.6875C7.35938 1.625 7.125 1.39062 7.125 1.0625ZM1.6875 1.25H4.6875C4.99219 1.25 5.25 1.50781 5.25 1.8125C5.25 2.14062 4.99219 2.375 4.6875 2.375H1.6875C1.35938 2.375 1.125 2.63281 1.125 2.9375V10.8125C1.125 11.1406 1.35938 11.375 1.6875 11.375H9.5625C9.86719 11.375 10.125 11.1406 10.125 10.8125V7.8125C10.125 7.50781 10.3594 7.25 10.6875 7.25C10.9922 7.25 11.25 7.50781 11.25 7.8125V10.8125C11.25 11.75 10.4766 12.5 9.5625 12.5H1.6875C0.75 12.5 0 11.75 0 10.8125V2.9375C0 2.02344 0.75 1.25 1.6875 1.25Z'
                                            fill='#3C9EE6'
                                          />
                                        </svg>
                                      </a>
                                    </p>
                                  )}
                                </div>
                              )}
                              {!order.content.orderAddress.frenet.TrackingURL && (
                                <Button
                                  icon='fa fa-barcode'
                                  color='primary'
                                  text={i18n.t(`reports.label`)}
                                  btnClass='mt-4 h-40px w-100 d-flex flex-row align-items-center justify-content-center'
                                  click={() => {
                                    setModalToShow('measures')
                                    showWrapperModal(i18n.t(`reports.label`))
                                  }}
                                />
                              )}
                            </>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                )}
                <div className='card mb-5' id='card-product' style={{minHeight: '26.5em'}}>
                  <div className='card-header py-5'>
                    <h3 className='card-title align-items-start flex-column'>
                      <span className='card-label fw-bolder fs-3 mb-1'>
                        {i18n.t(`reports.products`)}
                      </span>
                    </h3>
                  </div>
                  <div className='card-body'>
                    <div className='row'>
                      <div className='col-7'>
                        <b>{i18n.t(`reports.product`)}</b>
                      </div>
                      <div className='col-1'>
                        <b>{i18n.t(`reports.qtt`)}</b>
                      </div>
                      <div className='col-2'>
                        <b>{i18n.t(`reports.value`)}</b>
                      </div>
                      <div className='col-2'>
                        <b>{i18n.t(`reports.total`)}</b>
                      </div>
                    </div>
                    {order.smartOrder.map((product) => (
                      <>
                        <div className='row mt-4'>
                          {/* <div className='col-2 !pr-0'>
                            <div
                              className={`d-flex justify-content-center align-items-center ${styles.imgProduct}`}
                            >
                              {product.content && product.content.image ? (
                                <img src={product.content.image} alt='Imagem' />
                              ) : (
                                <svg
                                  width='12'
                                  height='11'
                                  viewBox='0 0 12 11'
                                  fill='none'
                                  xmlns='http://www.w3.org/2000/svg'
                                >
                                  <path
                                    d='M10.5 1.375H1.5C1.28906 1.375 1.125 1.5625 1.125 1.75V9.25V9.27344L1.21875 9.13281L3.09375 6.50781C3.21094 6.34375 3.375 6.25 3.5625 6.25C3.72656 6.25 3.91406 6.34375 4.00781 6.48438L4.73438 7.49219L6.67969 4.98438C6.77344 4.84375 6.9375 4.75 7.125 4.75C7.28906 4.75 7.45312 4.84375 7.57031 4.98438L10.7578 9.10938L10.875 9.25V1.75C10.875 1.5625 10.6875 1.375 10.5 1.375ZM1.5 0.25H10.5C11.3203 0.25 12 0.929688 12 1.75V9.25C12 10.0938 11.3203 10.75 10.5 10.75H1.5C0.65625 10.75 0 10.0938 0 9.25V1.75C0 0.929688 0.65625 0.25 1.5 0.25ZM3.375 4.75C2.95312 4.75 2.60156 4.53906 2.39062 4.1875C2.17969 3.85938 2.17969 3.41406 2.39062 3.0625C2.60156 2.73438 2.95312 2.5 3.375 2.5C3.77344 2.5 4.125 2.73438 4.33594 3.0625C4.54688 3.41406 4.54688 3.85938 4.33594 4.1875C4.125 4.53906 3.77344 4.75 3.375 4.75Z'
                                    fill='#6E7586'
                                  />
                                </svg>
                              )}
                            </div>
                          </div> */}
                          <div className='col-7'>
                            <div
                              className={`d-flex justify-content-center align-items-center mb-4 ${styles.imgProduct}`}
                            >
                              {product.content && product.content.image ? (
                                <img src={product.content.image} alt='Imagem' />
                              ) : (
                                <svg
                                  width='12'
                                  height='11'
                                  viewBox='0 0 12 11'
                                  fill='none'
                                  xmlns='http://www.w3.org/2000/svg'
                                >
                                  <path
                                    d='M10.5 1.375H1.5C1.28906 1.375 1.125 1.5625 1.125 1.75V9.25V9.27344L1.21875 9.13281L3.09375 6.50781C3.21094 6.34375 3.375 6.25 3.5625 6.25C3.72656 6.25 3.91406 6.34375 4.00781 6.48438L4.73438 7.49219L6.67969 4.98438C6.77344 4.84375 6.9375 4.75 7.125 4.75C7.28906 4.75 7.45312 4.84375 7.57031 4.98438L10.7578 9.10938L10.875 9.25V1.75C10.875 1.5625 10.6875 1.375 10.5 1.375ZM1.5 0.25H10.5C11.3203 0.25 12 0.929688 12 1.75V9.25C12 10.0938 11.3203 10.75 10.5 10.75H1.5C0.65625 10.75 0 10.0938 0 9.25V1.75C0 0.929688 0.65625 0.25 1.5 0.25ZM3.375 4.75C2.95312 4.75 2.60156 4.53906 2.39062 4.1875C2.17969 3.85938 2.17969 3.41406 2.39062 3.0625C2.60156 2.73438 2.95312 2.5 3.375 2.5C3.77344 2.5 4.125 2.73438 4.33594 3.0625C4.54688 3.41406 4.54688 3.85938 4.33594 4.1875C4.125 4.53906 3.77344 4.75 3.375 4.75Z'
                                    fill='#6E7586'
                                  />
                                </svg>
                              )}
                            </div>
                            <p className='mb-0'>
                              #{product.sku} {product.content.productName}
                            </p>
                            {product.variationHtml && (
                              <div dangerouslySetInnerHTML={{__html: product.variationHtml}} />
                            )}
                            {product.additionalHtml && (
                              <div dangerouslySetInnerHTML={{__html: product.additionalHtml}} />
                            )}
                            {product.fractionalHtml && (
                              <div dangerouslySetInnerHTML={{__html: product.fractionalHtml}} />
                            )}
                            {product.content.observation && (
                              <div
                                style={{
                                  display: 'flex',
                                  gap: '2px',
                                }}
                              >
                                <span
                                  className=''
                                  style={{
                                    fontSize: '11px',
                                    gap: '2px',
                                  }}
                                >
                                  Obs:
                                </span>
                                <span
                                  style={{
                                    fontSize: '11px',
                                    textDecoration: 'underline',
                                  }}
                                >
                                  {product.content.observation}
                                </span>
                              </div>
                            )}
                          </div>
                          <div className='col-1'>
                            <p className='mb-0'>{product.quantity}</p>
                          </div>
                          <div className='col-2'>
                            <p className='mb-0'>
                              {toMoney((product.price / 100).toFixed(2).toString())}
                            </p>
                            {parseFloat(product.discount) ? (
                              <p className='mb-0' style={{textDecoration: 'line-through'}}>
                                {toMoney(
                                  ((parseFloat(product.discount) + product.price) / 100)
                                    .toFixed(2)
                                    .toString()
                                )}
                              </p>
                            ) : (
                              <></>
                            )}
                          </div>
                          <div className='col-2'>
                            <p className='mb-0'>
                              {toMoney(
                                ((product.price * product.quantity) / 100).toFixed(2).toString()
                              )}
                            </p>
                            {parseFloat(product.discount) ? (
                              <p className='mb-0' style={{textDecoration: 'line-through'}}>
                                {toMoney(
                                  (
                                    ((parseFloat(product.discount) + product.price) *
                                      product.quantity) /
                                    100
                                  )
                                    .toFixed(2)
                                    .toString()
                                )}
                              </p>
                            ) : (
                              <></>
                            )}
                          </div>
                        </div>
                      </>
                    ))}
                    <div className='row mt-4'>
                      <div className='col-3'></div>
                      <div className='col-5'></div>
                      <div className='col-2'>
                        <p className='mb-0'>{i18n.t(`reports.product_value`)}</p>
                      </div>
                      <div className='col-2'>
                        <p className='mb-0'>
                          {toMoney((order.totalWithoutDiscount / 100).toFixed(2).toString())}
                        </p>
                      </div>
                    </div>
                    {order.content && order?.content.code === 'delivery' && order.deliveryTax && (
                      <div className='row mt-4'>
                        <div className='col-3'></div>
                        <div className='col-5'></div>
                        <div className='col-2'>
                          <p className='mb-0'>Frete</p>
                        </div>
                        <div className='col-2'>
                          <p className='mb-0'>
                            {toMoney((parseFloat(order.deliveryTax) / 100).toFixed(2).toString())}
                          </p>
                        </div>
                      </div>
                    )}

                    <div className='row mt-4'>
                      <div className='col-3'></div>
                      <div className='col-5'></div>
                      <div className='col-2'>
                        <p className='mb-0'>{i18n.t(`reports.discount`)}</p>
                      </div>
                      <div className='col-2'>
                        <p className='mb-0'>
                          {toMoney(
                            ((order.totalWithoutDiscount - order.total) / 100).toFixed(2).toString()
                          )}
                        </p>
                      </div>
                    </div>

                    <div className='row mt-4'>
                      <div className='col-3'></div>
                      <div className='col-5'></div>
                      <div className='col-2'>
                        <b className='mb-0'>Total</b>
                      </div>
                      <div className='col-2'>
                        <p className='mb-0'>
                          {toMoney(
                            (
                              (order.total +
                                parseFloat(order.deliveryTax ? order.deliveryTax : '0')) /
                              100
                            )
                              .toFixed(2)
                              .toString()
                          )}
                        </p>
                      </div>
                    </div>
                    {order.observation && (
                      <div className='row mt-2'>
                        <p style={{margin: 0}}>
                          <b>Observação</b>
                        </p>
                        <p style={{margin: 0}}>{order.observation}</p>
                      </div>
                    )}
                  </div>
                  <div className='px-9 pb-5'>
                    <Button
                      text={i18n.t(`buttons.back`)}
                      color='info'
                      size='small'
                      horizontalPadding={5}
                      btnAttr={{
                        type: 'button',
                      }}
                      click={() => {
                        navigate('/order/saleorder')
                      }}
                      btnClass='fw-bolder'
                    />
                  </div>
                </div>
              </div>
              <div className='d-flex flex-column' style={{flex: 1, width: '50%'}}>
                <div className='card mb-5' style={{minHeight: '16em', height: heightClient}}>
                  <div className='card-header py-5 d-flex justify-content-between align-items-center'>
                    <h3 className='card-title align-items-start flex-column'>
                      <span className='card-label fw-bolder fs-3 mb-1'>
                        {i18n.t(`reports.consumer`)}
                      </span>
                    </h3>
                    {order?.customer?.id && (
                      <span>
                        <Button
                          color='secondary'
                          icon='fas fa-external-link-alt'
                          iconColor='#3F4254'
                          text={i18n.t(`reports.details`)}
                          click={() => {
                            window.open(
                              `/customer/report/${btoa(String(order?.customer.id))}`,
                              '_blank',
                              'noreferrer'
                            )
                          }}
                          fontColor='#3F4254'
                        />
                      </span>
                    )}
                  </div>
                  <div className='card-body pb-5'>
                    {order.customer && (
                      <div>
                        <p className='mb-0'>
                          <b>{order?.customer.name}</b>
                        </p>
                        {order?.customer.doc && (
                          <p className='mb-0'>
                            {order.customer.doc.length <= 11
                              ? `CPF: ${numberToCpf(order.customer.doc)}`
                              : `CNPJ: ${numberToCnpj(order.customer.doc)}`}
                          </p>
                        )}
                        {order?.customer.email && (
                          <div className='d-flex flex-row gap-2 align-items-center'>
                            <p className='mb-0'>{order.customer.email}</p>
                            <svg
                              width='14'
                              height='11'
                              viewBox='0 0 14 11'
                              fill='none'
                              xmlns='http://www.w3.org/2000/svg'
                            >
                              <path
                                d='M1.75 1.8125C1.50391 1.8125 1.3125 2.03125 1.3125 2.25V2.87891L6.01562 6.73438C6.58984 7.19922 7.38281 7.19922 7.95703 6.73438L12.6875 2.87891V2.25C12.6875 2.03125 12.4688 1.8125 12.25 1.8125H1.75ZM1.3125 4.57422V9.25C1.3125 9.49609 1.50391 9.6875 1.75 9.6875H12.25C12.4688 9.6875 12.6875 9.49609 12.6875 9.25V4.57422L8.80469 7.74609C7.73828 8.62109 6.23438 8.62109 5.19531 7.74609L1.3125 4.57422ZM0 2.25C0 1.29297 0.765625 0.5 1.75 0.5H12.25C13.207 0.5 14 1.29297 14 2.25V9.25C14 10.2344 13.207 11 12.25 11H1.75C0.765625 11 0 10.2344 0 9.25V2.25Z'
                                fill='#3C9EE6'
                              />
                            </svg>
                          </div>
                        )}
                        {order?.customer.customerPhones &&
                          order?.customer.customerPhones.length > 0 && (
                            <div className='d-flex flex-row gap-2 align-items-center'>
                              <p className='mb-0'>
                                {formatPhone(
                                  order.customer.customerPhones[
                                    order.customer.customerPhones.length - 1
                                  ].numberPhone
                                )}
                              </p>
                              <svg
                                width='13px'
                                height='13px'
                                viewBox='0 0 24 24'
                                fill='none'
                                xmlns='http://www.w3.org/2000/svg'
                              >
                                <path
                                  fill-rule='evenodd'
                                  clip-rule='evenodd'
                                  d='M3.50002 12C3.50002 7.30558 7.3056 3.5 12 3.5C16.6944 3.5 20.5 7.30558 20.5 12C20.5 16.6944 16.6944 20.5 12 20.5C10.3278 20.5 8.77127 20.0182 7.45798 19.1861C7.21357 19.0313 6.91408 18.9899 6.63684 19.0726L3.75769 19.9319L4.84173 17.3953C4.96986 17.0955 4.94379 16.7521 4.77187 16.4751C3.9657 15.176 3.50002 13.6439 3.50002 12ZM12 1.5C6.20103 1.5 1.50002 6.20101 1.50002 12C1.50002 13.8381 1.97316 15.5683 2.80465 17.0727L1.08047 21.107C0.928048 21.4637 0.99561 21.8763 1.25382 22.1657C1.51203 22.4552 1.91432 22.5692 2.28599 22.4582L6.78541 21.1155C8.32245 21.9965 10.1037 22.5 12 22.5C17.799 22.5 22.5 17.799 22.5 12C22.5 6.20101 17.799 1.5 12 1.5ZM14.2925 14.1824L12.9783 15.1081C12.3628 14.7575 11.6823 14.2681 10.9997 13.5855C10.2901 12.8759 9.76402 12.1433 9.37612 11.4713L10.2113 10.7624C10.5697 10.4582 10.6678 9.94533 10.447 9.53028L9.38284 7.53028C9.23954 7.26097 8.98116 7.0718 8.68115 7.01654C8.38113 6.96129 8.07231 7.046 7.84247 7.24659L7.52696 7.52195C6.76823 8.18414 6.3195 9.2723 6.69141 10.3741C7.07698 11.5163 7.89983 13.314 9.58552 14.9997C11.3991 16.8133 13.2413 17.5275 14.3186 17.8049C15.1866 18.0283 16.008 17.7288 16.5868 17.2572L17.1783 16.7752C17.4313 16.5691 17.5678 16.2524 17.544 15.9269C17.5201 15.6014 17.3389 15.308 17.0585 15.1409L15.3802 14.1409C15.0412 13.939 14.6152 13.9552 14.2925 14.1824Z'
                                  fill='#128c7e'
                                />
                              </svg>
                            </div>
                          )}
                      </div>
                    )}
                  </div>
                </div>
                <div className='card mb-5'>
                  <div className='card-header py-5'>
                    <h3 className='card-title align-items-start flex-column'>
                      <span className='card-label fw-bolder fs-3 mb-1'>
                        {i18n.t(`reports.payment`)}
                      </span>
                    </h3>
                    <div className=''>
                      {canRefund(order.created) && canBeRefunded ? (
                        <Button
                          color='danger'
                          icon='fas fa-undo'
                          text='Estornar Pagamento'
                          size='small'
                          btnClass='w-100 h-40px d-flex flex-row align-items-center justify-content-center'
                          click={() => {
                            setModalToShow('refund')
                            showWrapperModal('Estornar Pagamento')
                          }}
                        />
                      ) : (
                        <div
                          className='position-relative'
                          onMouseEnter={() => setShowTooltip(true)}
                          onMouseLeave={() => setShowTooltip(false)}
                        >
                          <Button
                            color='secondary'
                            icon='fas fa-undo'
                            text='Estorno Indisponível'
                            size='small'
                            txtClass='text-black'
                            iconColor='#000'
                            disabled
                            btnClass='w-100 h-40px d-flex flex-row align-items-center justify-content-center'
                            click={() => console.log('Estorno Indisponível')}
                          />
                          <div
                            className={`position-absolute bg-dark text-white px-3 py-2 rounded ${
                              showTooltip ? 'd-block' : 'd-none'
                            }`}
                            style={{
                              fontSize: '12px',
                              whiteSpace: 'normal', // Mudança aqui: permite quebra de linha
                              maxWidth: '350px', // Mudança aqui: limita a largura
                              zIndex: 1000,
                              bottom: '100%',
                              left: '0%',
                              transform: 'translateX(-50%)',
                              marginBottom: '8px',
                            }}
                          >
                            <span>
                              {!hasBeenRefunded
                                ? `O estorno está indisponível para pagamentos realizados há mais de 30 dias ou para pagamentos realizados com Pix
                                    ou Pagamento na entrega. Em caso de dúvidas, entre em contato com o suporte.`
                                : `Este pedido já foi estornado.`}
                            </span>
                            <div
                              className='position-absolute'
                              style={{
                                top: '100%',
                                left: '50%',
                                transform: 'translateX(-50%)',
                                width: 0,
                                height: 0,
                                borderLeft: '6px solid transparent',
                                borderRight: '6px solid transparent',
                                borderTop: '6px solid #000',
                              }}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className='card-body'>
                    {order.content ? (
                      <>
                        {order.content &&
                          order.content.dataGateway &&
                          order.content.dataGateway.flagIdentifier === 'payOffline' && (
                            <div>
                              {order.content.dataGateway.paymentType === 99 &&
                              (order.content.dataGateway.codePay === 'dinheiro' ||
                                order.content.dataGateway.codePay === '100') ? (
                                <div className='d-flex flex-row align-items-center'>
                                  <svg
                                    style={{marginRight: 5}}
                                    width='16'
                                    height='14'
                                    viewBox='0 0 16 14'
                                    fill='none'
                                    xmlns='http://www.w3.org/2000/svg'
                                  >
                                    <path
                                      d='M7.24609 10.9062C7.38281 10.8789 7.49219 10.8516 7.62891 10.8242C9.16016 10.4414 10.8828 9.97656 12.6875 10.0312C12.7969 9.18359 13.5352 8.52734 14.4375 8.52734V3.6875C13.4531 3.6875 12.6875 2.92188 12.6875 1.96484C11.4023 1.91016 10.0352 2.21094 8.47656 2.62109C8.33984 2.64844 8.23047 2.67578 8.09375 2.70312C6.5625 3.08594 4.83984 3.55078 3.03516 3.49609C2.92578 4.34375 2.1875 5 1.3125 5V9.8125C2.26953 9.8125 3.03516 10.6055 3.0625 11.5625C4.34766 11.6172 5.6875 11.3164 7.24609 10.9062ZM0 11.2891V2.83984C0 2.18359 0.683594 1.74609 1.3125 1.91016C3.5 2.51172 5.6875 1.96484 7.875 1.41797C10.2266 0.816406 12.6055 0.1875 14.9844 1.08984C15.4492 1.25391 15.75 1.71875 15.75 2.23828V10.6602C15.75 11.3438 15.0391 11.7812 14.4102 11.5898C12.2227 10.9883 10.0352 11.5625 7.875 12.1094C5.49609 12.7109 3.11719 13.3125 0.738281 12.4375C0.273438 12.2734 0 11.7812 0 11.2891ZM7.875 9.375C6.64453 9.375 5.6875 8.19922 5.6875 6.75C5.6875 5.30078 6.64453 4.125 7.875 4.125C9.07812 4.125 10.0625 5.30078 10.0625 6.75C10.0625 8.19922 9.07812 9.375 7.875 9.375Z'
                                      fill='#E19C15'
                                    />
                                  </svg>
                                  <p className='mb-0'>{i18n.t(`reports.payment_money`)}</p>
                                </div>
                              ) : (
                                <>
                                  <p className='mb-0'>
                                    {i18n.t(`reports.payment_delivery`)}
                                    {order.content.dataGateway.paymentData ? (
                                      <>
                                        :{' '}
                                        {getPaymentType(
                                          order.content.dataGateway.paymentData.typePay
                                        )}{' '}
                                        {order.content.dataGateway.paymentData.brand.toUpperCase()}
                                      </>
                                    ) : (
                                      <></>
                                    )}
                                  </p>
                                </>
                              )}
                              <p className='mb-0' style={{color: '#6E7586'}}>
                                <b>Valor: </b>
                                {toMoney(
                                  (
                                    (order.total +
                                      parseFloat(order.deliveryTax ? order.deliveryTax : '0')) /
                                    100
                                  )
                                    .toFixed(2)
                                    .toString()
                                )}
                              </p>
                              {order.content.dataGateway.paymentData?.installment &&
                                order.content.dataGateway.paymentData?.installmentValue && (
                                  <p className='mb-0' style={{color: '#6E7586'}}>
                                    <b>Parcelamento: </b>
                                    {`${
                                      order.content.dataGateway.paymentData?.installment
                                    }x ${toMoney(
                                      order.content.dataGateway.paymentData?.installmentValue
                                        .toFixed(2)
                                        .toString()
                                    )}`}
                                  </p>
                                )}
                              {order.content.dataGateway.paymentType === 99 &&
                              order.content.changeMoney ? (
                                <p className='mb-0' style={{color: '#6E7586'}}>
                                  <b>Troco: </b>
                                  {toMoney((order.content.changeMoney / 100).toFixed(2).toString())}
                                </p>
                              ) : (
                                <></>
                              )}
                            </div>
                          )}

                        {order.content &&
                          order.content.dataGateway &&
                          order.content.dataGateway.flagIdentifier === 'pix' && (
                            <div>
                              <p className='mb-1'>
                                <svg
                                  style={{marginRight: '0.5em'}}
                                  width='20'
                                  height='21'
                                  viewBox='0 0 20 21'
                                  fill='none'
                                  xmlns='http://www.w3.org/2000/svg'
                                >
                                  <path
                                    d='M20.0036 9.99792C19.9836 9.15792 19.7039 8.43793 19.1045 7.83793C18.4052 7.11793 17.6859 6.41792 16.9866 5.69792C16.8867 5.59792 16.8068 5.53792 16.647 5.55792C16.3073 5.57792 15.9676 5.55792 15.628 5.55792C15.0486 5.55792 14.569 5.75792 14.1495 6.17792C13.1704 7.15792 12.1914 8.13793 11.2124 9.11792C10.573 9.75793 9.7139 9.73792 9.07454 9.11792C8.9147 8.95792 8.75486 8.79792 8.59501 8.63793C7.77583 7.81793 6.95665 6.99792 6.13747 6.17792C5.75785 5.79792 5.29831 5.57792 4.73887 5.55792C4.31929 5.55792 3.89971 5.55792 3.48013 5.55792C3.44017 5.55792 3.38023 5.55792 3.34027 5.55792C3.26035 5.53792 3.20041 5.55792 3.14047 5.61792C2.40121 6.35792 1.64197 7.11793 0.902706 7.85792C0.363245 8.39793 0.063545 9.05792 0.0435649 9.81792C0.0036049 10.7179 0.303305 11.4979 0.942666 12.1379C1.64197 12.8379 2.34127 13.5379 3.02059 14.2379C3.14047 14.3579 3.26035 14.4379 3.46015 14.4179C3.83977 14.3779 4.23937 14.3979 4.61899 14.4179C5.23837 14.4179 5.75785 14.1979 6.17743 13.7779C7.15645 12.7979 8.13547 11.7979 9.13448 10.8179C9.43418 10.5179 9.8138 10.3779 10.2334 10.3979C10.633 10.4179 10.9726 10.5979 11.2723 10.8979C12.2314 11.8779 13.2104 12.8579 14.1894 13.8179C14.4891 14.1179 14.8288 14.2979 15.2484 14.3579C15.5281 14.3979 15.8278 14.3979 16.1075 14.3979C16.3073 14.3979 16.5271 14.3779 16.7269 14.3979C16.8268 14.4179 16.8867 14.3779 16.9467 14.3179C17.6859 13.5779 18.4052 12.8579 19.1445 12.1179C19.6839 11.5579 19.9836 10.8379 20.0036 9.99792ZM15.9277 4.69793C15.9477 4.67793 15.9477 4.67792 15.9676 4.65792C15.9277 4.63792 15.8877 4.61792 15.8478 4.59792C14.629 3.37792 13.4102 2.15792 12.1914 0.937925C11.4921 0.237925 10.653 -0.0820748 9.67394 0.0179252C8.97464 0.0779252 8.37523 0.357925 7.87573 0.857925C6.63697 2.09792 5.39821 3.33792 4.15945 4.57792C4.13947 4.59792 4.11949 4.63792 4.07953 4.67792C4.27933 4.67792 4.47913 4.67792 4.65895 4.67792C5.45815 4.67792 6.13747 4.95792 6.71689 5.53793C7.71589 6.53792 8.69491 7.51792 9.69392 8.51792C9.97364 8.79792 10.2933 8.79792 10.573 8.51792C11.5521 7.53792 12.5311 6.55792 13.5101 5.57792C14.0895 4.99792 14.7888 4.69793 15.608 4.69793C15.7079 4.69793 15.8078 4.69793 15.9277 4.69793ZM4.07953 15.3179C4.05955 15.3379 4.05955 15.3379 4.03957 15.3579C4.07953 15.3779 4.11949 15.3979 4.15945 15.4179C5.37823 16.6179 6.57703 17.8379 7.79581 19.0579C8.49512 19.7579 9.33428 20.0779 10.3133 19.9779C11.0126 19.9179 11.612 19.6379 12.0915 19.1379C13.3503 17.8779 14.609 16.6379 15.8478 15.3779C15.8677 15.3579 15.8877 15.3379 15.9277 15.2979C15.8478 15.2979 15.8078 15.2979 15.7479 15.2979C15.588 15.2979 15.4082 15.2979 15.2484 15.2779C14.5491 15.1979 13.9497 14.8979 13.4502 14.3779C12.4911 13.4179 11.5121 12.4579 10.573 11.4779C10.3133 11.2179 9.9137 11.2179 9.65396 11.4779C8.69491 12.4379 7.73587 13.3979 6.77683 14.3779C6.15745 14.9979 5.41819 15.3179 4.53907 15.2979C4.37923 15.3179 4.23937 15.3179 4.07953 15.3179Z'
                                    fill='#37393D'
                                  />
                                  <path
                                    d='M20.0035 9.99794C19.9835 10.8179 19.7038 11.5379 19.1244 12.1379C18.3851 12.8779 17.6659 13.5979 16.9266 14.3379C16.8667 14.3979 16.8067 14.4379 16.7068 14.4179C16.507 14.3979 16.2872 14.4179 16.0874 14.4179C15.8077 14.4179 15.508 14.4179 15.2283 14.3779C14.8087 14.3179 14.4691 14.1179 14.1694 13.8379C13.1903 12.8579 12.2113 11.8979 11.2523 10.9179C10.9526 10.5979 10.6129 10.4179 10.1933 10.3979C9.77376 10.3779 9.39413 10.5179 9.09443 10.8179C8.11541 11.7979 7.11641 12.7779 6.13739 13.7779C5.69783 14.2179 5.19833 14.4379 4.57895 14.4179C4.19933 14.4179 3.79973 14.3979 3.42011 14.4179C3.22031 14.4379 3.10043 14.3579 2.98055 14.2379C2.28125 13.5379 1.58195 12.8379 0.902627 12.1379C0.263266 11.5179 -0.0364342 10.7379 0.00352589 9.83794C0.0434859 9.07794 0.323206 8.41794 0.862667 7.87794C1.60193 7.13794 2.36117 6.37794 3.10043 5.63793C3.16037 5.57793 3.20033 5.55793 3.30023 5.57793C3.34019 5.59793 3.40013 5.57793 3.44009 5.57793C3.85967 5.57793 4.27925 5.57793 4.69883 5.57793C5.23829 5.59793 5.71781 5.79793 6.09743 6.19793C6.91661 7.01794 7.73579 7.83794 8.55497 8.65794C8.71481 8.81794 8.87465 8.97794 9.03449 9.13794C9.67386 9.77794 10.533 9.77794 11.1724 9.13794C12.1514 8.15794 13.1304 7.17794 14.1094 6.19793C14.509 5.79793 15.0085 5.59793 15.5879 5.57793C15.9276 5.57793 16.2673 5.59793 16.6069 5.57793C16.7668 5.55793 16.8467 5.61793 16.9466 5.71793C17.6459 6.43793 18.3652 7.13793 19.0645 7.85794C19.6838 8.43794 19.9835 9.17794 20.0035 9.99794Z'
                                    fill='#2CB4A9'
                                  />
                                  <path
                                    d='M15.9277 4.69793C15.8278 4.69793 15.708 4.69793 15.6081 4.69793C14.7889 4.69793 14.0896 4.99792 13.5102 5.57792C12.5311 6.55792 11.5521 7.53792 10.5731 8.51792C10.2934 8.79792 9.9737 8.79792 9.69398 8.51792C8.69497 7.51792 7.71595 6.53792 6.71695 5.53793C6.15751 4.97792 5.45821 4.69792 4.65901 4.67792C4.47919 4.67792 4.27939 4.67792 4.07959 4.67792C4.11955 4.63792 4.13953 4.59792 4.15951 4.57792C5.39827 3.33792 6.63703 2.09792 7.87579 0.857925C8.37529 0.357925 8.9747 0.0979252 9.674 0.0179252C10.653 -0.0820748 11.4922 0.237925 12.1915 0.937925C13.4103 2.15792 14.629 3.37792 15.8278 4.57792C15.8678 4.61792 15.9078 4.61793 15.9477 4.63793C15.9477 4.65793 15.9277 4.67793 15.9277 4.69793Z'
                                    fill='#2CB4A9'
                                  />
                                  <path
                                    d='M4.07951 15.3179C4.23935 15.3179 4.37921 15.3179 4.53905 15.3179C5.41817 15.3379 6.15743 15.0179 6.77681 14.3979C7.73585 13.4379 8.69489 12.4779 9.65394 11.4979C9.91368 11.2379 10.3133 11.2379 10.573 11.4979C11.5321 12.4779 12.4911 13.4379 13.4501 14.3979C13.9496 14.8979 14.549 15.1979 15.2483 15.2979C15.4082 15.3179 15.588 15.2979 15.7478 15.3179C15.8078 15.3179 15.8477 15.3179 15.9277 15.3179C15.8877 15.3579 15.8677 15.3779 15.8477 15.3979C14.589 16.6579 13.3502 17.9179 12.0915 19.1579C11.592 19.6379 10.9926 19.9179 10.3133 19.9979C9.33426 20.0979 8.49509 19.7779 7.79579 19.0779C6.59699 17.8579 5.37821 16.6579 4.15943 15.4379C4.11947 15.3979 4.07951 15.3979 4.03955 15.3779C4.05953 15.3379 4.07951 15.3379 4.07951 15.3179Z'
                                    fill='#2CB4A9'
                                  />
                                </svg>
                                PIX
                              </p>
                              <p className='mb-0' style={{color: '#6E7586'}}>
                                {`${i18n.t(`reports.transaction`)}: ${
                                  order.content.dataGateway.authorization
                                }`}
                              </p>
                              <p className='mb-0' style={{color: '#6E7586'}}>
                                {`${i18n.t(`reports.made_in`)}: ${toDateTime(order.created)}`}
                              </p>
                            </div>
                          )}

                        {order.content &&
                          order.content.dataGateway &&
                          order.content.dataGateway.flagIdentifier !== 'pix' &&
                          order.content.dataGateway.flagIdentifier !== 'payOffline' && (
                            <div>
                              <p className='mb-0'>
                                <i
                                  style={{color: '#3C9EE5', marginRight: '0.5em'}}
                                  className='fa fa-credit-card'
                                ></i>
                                Cartão de crédito
                              </p>
                              <p className='mb-0' style={{color: '#6E7586'}}>
                                {order.content.dataGateway.cardTicket
                                  ? formatCard(order.content.dataGateway.cardTicket)
                                  : order.content.dataGateway.ctk
                                  ? formatCard(order.content.dataGateway.ctk)
                                  : ''}
                                {order.content.dataGateway.flagIdentifier
                                  ? ' ' + order.content.dataGateway.flagIdentifier.toUpperCase()
                                  : ''}
                              </p>
                              {order.content.dataGateway.portion_numInstallments ? (
                                <p style={{color: '#6E7586'}}>
                                  {`Parcelamento: ${order.content.dataGateway.portion_numInstallments} X `}
                                  {toMoney(
                                    (
                                      (order.total +
                                        parseFloat(order.deliveryTax ? order.deliveryTax : '0')) /
                                      100 /
                                      order.content.dataGateway.portion_numInstallments
                                    )
                                      .toFixed(2)
                                      .toString()
                                  )}
                                </p>
                              ) : (
                                <></>
                              )}
                              <p className={`mb-0`}>
                                {`${i18n.t(`reports.approval_moment`)}: ${toDateTime(
                                  order.created
                                )}`}
                              </p>
                              {order.content.dataGateway.status && (
                                <p className={`mb-0`}>
                                  {`${i18n.t(`reports.status_payment`)}: ${formatStatusPayment(
                                    order.content.dataGateway.status
                                  )}`}
                                </p>
                              )}
                              {order.content.dataGateway.capture &&
                                order.content.dataGateway.capture.AuthorizationCode && (
                                  <p className={`mb-0`}>
                                    {`${i18n.t(
                                      `reports.authorization_code`
                                    )}: ${formatStatusPayment(
                                      order.content.dataGateway.capture.AuthorizationCode
                                    )}`}
                                  </p>
                                )}
                              {order.content.dataGateway.payment &&
                                order.content.dataGateway.payment.nsu && (
                                  <p className={`mb-0`}>
                                    NSU:{' '}
                                    {formatStatusPayment(order.content.dataGateway.payment.nsu)}
                                  </p>
                                )}
                            </div>
                          )}

                        {/* {order.content && order.content.dataGateway && (
                          <div className='mt-4'>
                            <p className='mb-0'>
                              <b>NSU:</b>{' '}
                              {order.content.dataGateway.nsu
                                ? order.content.dataGateway.nsu
                                : order.content.dataGateway.payment.nsu}
                            </p>
                            {order.content.dataGateway.authorization && (
                              <p className='mb-0'>
                                <b>Código de autorização:</b> {order.content.dataGateway.authorization}
                              </p>
                            )}
                          </div>
                        )} */}
                      </>
                    ) : (
                      <p className='mb-0'>
                        Forma de pagamento inexistente, pedido feito na mesa ou comanda.
                      </p>
                    )}
                    {discountCoupom && (
                      <div className='mt-1'>
                        <p className='mb-0' style={{color: '#6E7586'}}>
                          <b> Cupom de Desconto:</b> {discountCoupom.discountCoupons.nameCoupom}
                        </p>
                        <p className='mb-0' style={{color: '#6E7586'}}>
                          <b> Desconto de :</b>{' '}
                          {discountCoupom.discountCoupons.valueDiscount
                            ? floatToPrice(parseFloat(discountCoupom.discountCoupons.valueDiscount))
                            : `${discountCoupom.discountCoupons.percentageDiscount}%`}
                        </p>
                      </div>
                    )}
                    {discountPaymentType && (
                      <div className='mt-1'>
                        <p className='mb-0' style={{color: '#6E7586'}}>
                          <b> Desponto por meio de pagamento: </b>
                          {discountPaymentType.type !== 'percentage'
                            ? floatToPrice(parseFloat(discountPaymentType.discountValue))
                            : `${discountPaymentType.discountValue}%`}
                        </p>
                      </div>
                    )}
                    {/* NOVA SEÇÃO: Botão de Estorno */}
                  </div>
                </div>
                {clearsaleOrder && (
                  <div className='card card-xxl-stretch mb-5 mb-xl-12'>
                    <div className='card-header py-5'>
                      <h3 className='card-title align-items-start flex-column'>
                        <span className='card-label fw-bolder fs-3 mb-1'>Status da ClearSale</span>
                      </h3>
                    </div>
                    <div className='card-body'>
                      {clearsaleOrder.code && (
                        <div>
                          <p className='mb-0'>
                            <b>Code:</b>
                            {` ${clearsaleOrder.code}`}
                          </p>
                        </div>
                      )}
                      {clearsaleOrder.status && (
                        <div className='mt-2'>
                          <p className='mb-0'>
                            <b>Status:</b>
                            {` ${clearsaleOrder.status}`}
                          </p>
                        </div>
                      )}
                      {clearsaleOrder.score && (
                        <div className='mt-2'>
                          <p className='mb-0'>
                            <b>Score:</b>
                            {` ${clearsaleOrder.score}`}
                          </p>
                        </div>
                      )}
                      <div className='d-flex flex-row gap-4 align-items-end mt-4'>
                        <Button
                          color='primary'
                          text='Atualizar Pedido'
                          btnClass='h-40px d-flex flex-row align-items-center'
                          click={async () => await getClearsaleOrder(order, true)}
                        />
                      </div>
                    </div>
                  </div>
                )}
                <div className='card mb-5' style={{minHeight: '26.5em', height: heightOrder}}>
                  <div className='card-header py-5'>
                    <h3 className='card-title align-items-start flex-column'>
                      <span className='card-label fw-bolder fs-3 mb-1'>
                        {i18n.t(`reports.historial`)}
                      </span>
                    </h3>
                  </div>
                  <div className='card-body' style={{overflowY: auto}}>
                    {order.content ? (
                      order.orderStatus.map((orderSt) => (
                        <div className='d-flex flex-row align-items-center mt-2'>
                          <div className='col-3'>
                            <p className='mb-0'>{toDateTime(orderSt.created)}</p>
                          </div>
                          <div className='d-flex flex-row align-items-center'>
                            <p className='mb-0' style={{marginLeft: 5}}>
                              {orderSt.status}
                            </p>
                          </div>
                        </div>
                      ))
                    ) : (
                      <p className='mb-0'>Pedido finalizado em mesa ou comanda.</p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
          {modalToShow === 'balance' ? (
            <ModalWrapper confirmAction={() => {}} noAction noCloseButton>
              <div className='d-flex flex-column gap-4 mt-4'>
                <p style={{color: '#37393D', margin: 0}}>
                  {i18n.t(`frenet.value_balance`).replace('@', floatToPrice(balance))}
                </p>
                <p style={{color: '#37393D', margin: 0}}>{i18n.t(`frenet.print_balance`)}</p>
                <p style={{color: '#37393D', margin: 0}}>{i18n.t(`frenet.click_balance`)}</p>
                <a href='https://frenet.com.br' target='_blank' className={styles.frenetButton}>
                  {i18n.t(`frenet.open_balance`)}
                </a>
              </div>
            </ModalWrapper>
          ) : modalToShow === 'measures' ? (
            <ModalWrapper
              confirmAction={() => {}}
              width={70}
              maxWidth
              noCloseButton
              noCloseOverlay
              onCloseAction={() => {
                setHeight(0)
                setWidth(0)
                setLength(0)
                setWeight(0)
                setServiceFinded(undefined)
              }}
              noAction
            >
              <div className='d-flex justify-content-between align-items-center'>
                <div className='modal-body text-break p-0'>
                  {loadingFrenet ? (
                    <Loading />
                  ) : (
                    <div className='d-flex flex-column justify-content-center align-items-center w-100 mt-2 mb-8'>
                      <div className='d-flex flex-row align-items-center gap-4 w-100'>
                        <Input
                          inputAttr={{
                            type: 'number',
                          }}
                          placeholder='-'
                          label={i18n.t('reports.height')}
                          minNumber={0}
                          name={i18n.t('reports.height')}
                          value={height}
                          change={(value: number) => {
                            if (value > 0) setHeight(value)
                          }}
                          disabled={serviceFinded !== undefined}
                        />
                        <Input
                          inputAttr={{
                            type: 'number',
                          }}
                          placeholder='-'
                          label={i18n.t('reports.width')}
                          minNumber={0}
                          name={i18n.t('reports.width')}
                          value={width}
                          change={(value: number) => {
                            if (value > 0) setWidth(value)
                          }}
                          disabled={serviceFinded !== undefined}
                        />
                        <Input
                          inputAttr={{
                            type: 'number',
                          }}
                          placeholder='-'
                          label={i18n.t('reports.length')}
                          minNumber={0}
                          name={i18n.t('reports.length')}
                          value={length}
                          change={(value: number) => {
                            if (value > 0) setLength(value)
                          }}
                          disabled={serviceFinded !== undefined}
                        />
                        <Input
                          inputAttr={{
                            type: 'number',
                          }}
                          placeholder='-'
                          label={i18n.t('reports.weight')}
                          minNumber={0}
                          name={i18n.t('reports.weight')}
                          value={weight}
                          change={(value: number) => {
                            if (value > 0) setWeight(value)
                          }}
                          disabled={serviceFinded !== undefined}
                        />
                      </div>
                      <div className='d-flex flex-row align-items-center gap-4 w-100'>
                        <Input
                          inputAttr={{
                            type: 'select',
                          }}
                          label={i18n.t('frenet.value')}
                          options={[
                            {
                              select: i18n.t(`frenet.use`),
                              value: true,
                            },
                            {
                              select: i18n.t(`frenet.dont_use`),
                              value: false,
                            },
                          ]}
                          value={declaredValue}
                          change={setDeclaredValue}
                          disabled={serviceFinded !== undefined}
                          smalltext={i18n.t('frenet.declared_value')}
                        />
                      </div>
                      {serviceFinded && (
                        <div className='d-flex flex-row align-items-center mt-4 w-100 justify-content-start gap-2'>
                          <b>{i18n.t(`reports.send_text`)} </b>
                          <p style={{margin: 0}}>
                            {serviceFinded.ServiceDescription
                              ? serviceFinded.ServiceDescription
                              : serviceFinded.Carrier}{' '}
                            {floatToPrice(parseFloat(serviceFinded.ShippingPrice))}
                          </p>
                        </div>
                      )}
                      <div className='mt-4 d-flex flex-row justify-content-end w-100'>
                        <button
                          type='button'
                          className='btn btn-primary me-3'
                          onClick={async () =>
                            serviceFinded ? await printLabel() : await posCotationFrenet()
                          }
                        >
                          {serviceFinded ? i18n.t(`reports.confirm`) : i18n.t(`reports.continue`)}
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </ModalWrapper>
          ) : modalToShow === 'print' ? (
            <ModalWrapper
              confirmAction={() => printOrder()}
              noAction={false}
              width={80}
              shouldCloseModal={false}
              noCloseOverlay={isPrinting}
              onCloseAction={() => !isPrinting}
              disableButton={isPrinting}
              isFooterFixed={true}
              textAction={
                modalToShow === 'print' && isPrinting ? (
                  <Loading height={20} width={20} />
                ) : modalToShow === 'print' ? (
                  'Imprimir'
                ) : (
                  ''
                )
              }
            >
              <p className='mt-4'>{i18n.t(`order_print.title`)}</p>
              <div className='card'>
                <div className='card-header text-white d-flex align-items-center justify-content-between bg-primary'>
                  <h5 className='mb-0 text-start'>{i18n.t(`order_print.order_details`)}</h5>
                </div>
                <div className='card-body'>
                  <ul className='list-unstyled mb-0'>
                    <li className='mb-3'>
                      <strong>Id:</strong>{' '}
                      <span className='text-muted'>
                        {'#'}
                        {order?.id}
                      </span>
                    </li>
                    <li className='mb-3'>
                      <strong>{i18n.t(`order_print.client`)}:</strong>{' '}
                      <span className='text-muted'>{order?.customer?.name || '</>'}</span>
                    </li>
                    <li className='mb-3'>
                      <strong>Status:</strong>{' '}
                      <span className='text-muted'>{order?.orderStatus[0].status}</span>
                    </li>
                  </ul>
                </div>
              </div>

              <div className='mt-4'>
                <p>{i18n.t(`order_print.information`)}</p>
              </div>

              {resultPrint && (
                <div
                  className={`${resultPrint.success ? styles.successLog : styles.errorLog} mt-8`}
                >
                  <svg
                    width='50'
                    height='50'
                    viewBox='0 0 20 20'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      d='M9.6875 2.82031L1.95312 15.5156C1.875 15.6328 1.875 15.7109 1.875 15.8281C1.875 16.1406 2.10938 16.375 2.42188 16.375H17.5391C17.8516 16.375 18.125 16.1406 18.125 15.8281C18.125 15.7109 18.0859 15.6328 18.0078 15.5156L10.2734 2.82031C10.2344 2.70312 10.1172 2.625 10 2.625C9.84375 2.625 9.76562 2.70312 9.6875 2.82031ZM8.08594 1.84375C8.47656 1.17969 9.21875 0.75 10 0.75C10.7422 0.75 11.4844 1.17969 11.875 1.84375L19.6094 14.5391C19.8438 14.9297 20 15.3594 20 15.8281C20 17.1562 18.9062 18.25 17.5391 18.25H2.42188C1.09375 18.25 0 17.1562 0 15.8281C0 15.3594 0.117188 14.9297 0.351562 14.5391L8.08594 1.84375ZM11.25 13.875C11.25 14.5781 10.6641 15.125 10 15.125C9.29688 15.125 8.75 14.5781 8.75 13.875C8.75 13.2109 9.29688 12.625 10 12.625C10.6641 12.625 11.25 13.2109 11.25 13.875ZM10.9375 6.6875V10.4375C10.9375 10.9844 10.5078 11.375 10 11.375C9.45312 11.375 9.0625 10.9844 9.0625 10.4375V6.6875C9.0625 6.17969 9.45312 5.75 10 5.75C10.5078 5.75 10.9375 6.17969 10.9375 6.6875Z'
                      fill={resultPrint.success ? '#67BF5F' : '#EB5353'}
                    />
                  </svg>

                  <p className='mt-2' style={{color: resultPrint.success ? '#67BF5F' : '#EB5353'}}>
                    {resultPrint.message}
                  </p>
                </div>
              )}
            </ModalWrapper>
          ) : modalToShow === 'refund' ? (
            <ModalWrapper
              confirmAction={handleRefund}
              //loading={refundLoading}
              noCloseOverlay
              zIndex={1000}
              shouldCloseModal={false}
              disableButton={refundLoading}
              textAction={refundLoading ? <Loading height={20} width={20} /> : 'Confirmar Estorno'}
              onCloseAction={() => setRefundLoading(false)}
            >
              <div className='d-flex flex-column gap-4 mt-4'>
                <div className='d-flex justify-content-center mb-4'>
                  <KTSVG
                    path='/media/icons/duotune/general/gen044.svg'
                    className='svg-icon'
                    svgClassName='h-80px w-80px text-warning'
                  />
                </div>
                <h4 className='text-center mb-4'>Confirmar Estorno</h4>
                <p className='text-center mb-0'>
                  Tem certeza que deseja estornar o pagamento deste pedido?
                </p>
                <p className='text-center mb-0 fw-bold'>
                  Valor:{' '}
                  {toMoney(
                    (((order?.total || 0) + parseFloat(order?.deliveryTax || '0')) / 100)
                      .toFixed(2)
                      .toString()
                  )}
                </p>
                <div className='alert alert-warning mt-3' id='refund-warning'>
                  <strong>Atenção:</strong> Esta ação não pode ser desfeita. O valor será estornado
                  na forma de pagamento original.
                </div>
              </div>
            </ModalWrapper>
          ) : (
            <ModalWrapper
              confirmAction={() => saveOrder()}
              onCloseAction={() => setLoadingStatus(false)}
            >
              <div className='d-flex justify-content-between align-items-center'>
                <div className='modal-body text-break pt-0'>
                  <div className='d-flex flex-column justify-content-center align-items-center w-100 mt-2 px-10'>
                    <KTSVG
                      path='/media/icons/duotune/general/gen044.svg'
                      className={`svg-icon`}
                      svgClassName={`h-100px w-100px`}
                    />
                    <p className='mt-2'>O status desejado é anterior ao que ele já está.</p>
                    <p>Deseja mesmo alterar este item?</p>
                  </div>
                </div>
              </div>
            </ModalWrapper>
          )}
        </div>
      )}
    </>
  )
}

const PedidosView: FC = () => {
  const {id} = useParams()
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {title: 'Dashboard', path: 'dashboard', isActive: true},
          {title: i18n.t(`reports.order_report`), path: 'order/saleorder', isActive: true},
          {
            title: `${i18n.t(`reports.order`)} #${id}`,
            path: `order/saleorder/${id}`,
            isActive: true,
          },
        ]}
      >
        {i18n.t(`reports.order_report`)}
      </PageTitle>
      <PedidosViewContent />
    </>
  )
}

export {PedidosView}
